import { useSelector } from "@jti/store";
const useLoggedUser = () => {
    const { isLogged } = useSelector((state) => state.loyaltyCore);
    const user = useSelector((state) => state.loyaltyCore);
    return [isLogged, isLogged ? user : null];
};
export default useLoggedUser;
//# sourceMappingURL=useLoggedUser.js.map